import { Row, Col, Card, Spinner } from 'react-bootstrap'
import { formatDateTime, formatTimeAgo } from './user-activity-format'

// The three login numbers the admin users table sorts on, repeated on the user
// they clicked into. Values come from the show payload (`login_stats`), which is
// computed from the same Ahoy visits as the table, so the two always agree.
const StatCard = ({ title, value, caption }) => (
  <Card className="h-100">
    <Card.Body className="text-center">
      <Card.Title className="text-muted fs-6">{title}</Card.Title>
      <div className="fs-2 fw-bold">{value}</div>
      {caption && <div className="small text-muted">{caption}</div>}
    </Card.Body>
  </Card>
)

const UserLoginStats = ({ loginStats, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="text-center mb-4">
        <Spinner animation="border" size="sm" />
      </div>
    )
  }

  if (!loginStats) return null

  const { total_logins: total, recent_logins: recent, last_login_at: lastLogin, window_days: windowDays } = loginStats

  return (
    <Row className="mb-4">
      <Col md className="mb-3">
        <StatCard title="Total Logins" value={total?.toLocaleString() ?? '--'} caption="All time" />
      </Col>
      <Col md className="mb-3">
        <StatCard
          title={`Logins (Last ${windowDays} Days)`}
          value={recent?.toLocaleString() ?? '--'}
          caption={recent > 0 ? 'Signed in this period' : 'No logins this period'}
        />
      </Col>
      <Col md className="mb-3">
        <StatCard
          title="Last Login"
          value={lastLogin ? formatTimeAgo(lastLogin) : 'Never'}
          caption={lastLogin ? formatDateTime(lastLogin) : 'No recorded sessions'}
        />
      </Col>
    </Row>
  )
}

export default UserLoginStats
